(function () {
    'use strict';

    angular
        .module(app.modules.common.name)
        .factory('scrollData', scrollDataFactory);

    scrollDataFactory.$inject = ['itemElement'];
    function scrollDataFactory(itemElement) {
        return function scrollData(options) {
            var
                // Options
                scrollParent = options.scrollParent,
                scrollBox = options.scrollBox,
                data = options.data,
                pageSize = options.pageSize,
                itemIndex = options.itemIndex,
                itemCount = options.itemCount,
                itemHeight = options.itemHeight,
                threshold = options.threshold,

                // Vars
                parentRect = scrollParent.clientRect(),
                // boxRect = scrollBox.clientRect(),
                boxRect = getScrollBoxRect(),
                firstItem = data[0],
                firstRect = itemElement(firstItem).clientRect(),
                lastItem = data[data.length - 1],
                lastRect = itemElement(lastItem).clientRect(),
                halfPageSize = Math.round(pageSize / 2);

            return (
                data.length < 2 ? null :
                boxRect.top >= parentRect.top ? boxTopAfterViewportTop() :
                boxRect.bottom <= parentRect.bottom ? boxBottomBeforeViewportBottom() :
                firstRect.top - parentRect.top > threshold && firstRect.top <= parentRect.bottom ? firstVisible() :
                firstRect.top - parentRect.top > threshold && firstRect.top > parentRect.bottom ? firstBelowViewport() :
                parentRect.bottom - lastRect.bottom > threshold && lastRect.bottom >= parentRect.top ? lastVisible() :
                parentRect.bottom - lastRect.bottom > threshold && lastRect.bottom < parentRect.top ? lastAboveViewport() :
                null);


            function boxTopAfterViewportTop() {
                console.log('Box top after viewport top');
                return {
                    index: 0,
                    scrollFrom: 'begin',
                    scrollOffset: scrollParent.scrollTop()
                };
            }
            function boxBottomBeforeViewportBottom() {
                console.log('Box bottom before viewport bottom');
                return {
                    index: Math.max(0, itemCount - pageSize),
                    scrollFrom: 'end',
                    scrollOffset: scrollParent.scrollTop() - scrollParent.scrollHeight()
                };
            }
            function firstVisible() {
                console.log('First element is visible');
                return adjustIfNeeded({
                    index: itemIndex - halfPageSize,
                    scrollFrom: 'element',
                    scrollOffset: Math.round(firstRect.top - parentRect.top),
                    elementIndex: halfPageSize,
                    elementId: firstItem.id
                });
            }
            function firstBelowViewport() {
                console.log('First element is below the viewport');
                var count = (firstRect.top - parentRect.bottom) / itemHeight;
                return adjustIfNeeded({
                    index: itemIndex - halfPageSize - Math.ceil(count),
                    scrollFrom: 'element',
                    scrollOffset: parentRect.height - (itemHeight - (count % 1) * itemHeight),
                    elementIndex: halfPageSize
                });
            }
            function lastVisible() {
                console.log('Last element is visible');
                return adjustIfNeeded({
                    index: itemIndex + data.length - 1 - halfPageSize,
                    scrollFrom: 'element',
                    scrollOffset: Math.round(lastRect.top - parentRect.top),
                    elementIndex: halfPageSize,
                    elementId: lastItem.id
                });
            }
            function lastAboveViewport() {
                console.log('Last element is above the viewport');
                var count = (parentRect.top - lastRect.bottom) / itemHeight;
                return adjustIfNeeded({
                    index: itemIndex + data.length - 1 - halfPageSize + Math.ceil(count),
                    scrollFrom: 'element',
                    scrollOffset: 0 - (itemHeight - (count % 1) * itemHeight),
                    elementIndex: halfPageSize
                });
            }
            function adjustIfNeeded(result) {
                var maxIndex = itemCount - pageSize;

                if (result.index < 0) {
                    result.elementIndex = result.elementIndex + result.index;
                    result.index = 0;
                    if (result.elementIndex < 0) {
                        result.elementIndex = 0;
                        result.scrollOffset = 0;
                    }
                }
                else if (result.index > maxIndex) {
                    result.elementIndex = result.elementIndex + (result.index - maxIndex);
                    result.index = maxIndex;
                    if (result.elementIndex > pageSize - 1) {
                        result.elementIndex = pageSize - 1;
                        result.scrollOffset = 0;
                    }
                }

                return result;
            }
            function getScrollBoxRect() {
                var rect = scrollBox.clientRect();
                // DomRect properties are readonly and apparently non enumerable.  Hence no angular.copy.
                return {
                    top: rect.top + parseInt(scrollBox.css('marginTop')),
                    right: rect.right,
                    bottom: rect.bottom + parseInt(scrollBox.css('marginBottom')),
                    left: rect.left,
                    width: rect.width,
                    height: rect.height,
                };
            }
        }
    }
})();